import axios from "axios";
import { ComparatorTypeDto } from "components/annotations/interface";
import { IAxiosReturn } from "functions/api/interface";
import { processAxiosError } from "functions/api/processAxiosError";

export type IComparatorTypesReturn = IAxiosReturn<ComparatorTypeDto[]>;

/**
 * Fetches comparator types from the backend API.
 *
 * @param backEndUrl - The base URL for the backend API.
 * @returns An object containing success status and the list of comparator types.
 */
export const getComparatorTypes = async (backEndUrl: string): Promise<IComparatorTypesReturn> => {
  const url = `${backEndUrl}Annotations/Comparators`;
  try {
    const response: { data: ComparatorTypeDto[] } = await axios.get(url);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("Load comparator types failed", error);
  }
};
